import type { ComponentProps } from 'react'

import { Icon } from '@/components/icon'
import { cn } from '@/infra'

type EmptyStateProps = {
  icon?: ComponentProps<typeof Icon>['name']
  title: string
  description: string
  className?: string
  iconClassName?: string
  titleClassName?: string
  descriptionClassName?: string
}

export const EmptyState = ({
  icon = 'blocks',
  title,
  description,
  className,
  iconClassName,
  titleClassName,
  descriptionClassName,
}: EmptyStateProps) => {
  return (
    <div className={cn('flex flex-col items-center justify-center rounded-lg px-8 py-16', className)}>
      <div className="mb-6 rounded-full bg-orange-100 p-3">
        <Icon name={icon} className={cn('stroke-2 text-neutral-600', iconClassName)} size={36} />
      </div>
      <h3 className={cn('text-md mb-2 text-center font-semibold tracking-wide text-neutral-700', titleClassName)}>
        {title}
      </h3>
      <p
        className={cn('font-nunito max-w-80 text-center text-sm tracking-wide text-neutral-800', descriptionClassName)}
      >
        {description}
      </p>
    </div>
  )
}
